import { render, staticRenderFns } from "./RewardCardList.vue?vue&type=template&id=15544119&"
import script from "./RewardCardList.vue?vue&type=script&lang=js&"
export * from "./RewardCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports